import { useContext, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import { GlobalAppContext } from '../../../context/GlobalContext';
import ToasterHelper from '../../../shared/helpers/toaster.helper';
import * as SignInService from '../../../services/signin.service';
import { setItem } from '../../../services/session-storage.service';
import Redirect from '../../redirect/redirect';
import { IUser } from '../../../models/interfaces/user.interface';
import { ISignIn } from '../../../models/interfaces/signin.interface';
import { isValidEmail } from '../../../shared/helpers/utils.helper';
import { Link } from 'react-router-dom';

export default function UserSignIn() {
  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const { token, setToken, setUser, setIsUserSignedIn } = useContext(GlobalAppContext);

  const validateEmail = (event: any) => {
    if (!isValidEmail(event.target.value)) {
      setEmailInvalid(true);
    } else {
      setEmailInvalid(false);
    }
    event.preventDefault();
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === true) {
      const input: ISignIn = {
        email: form.signInEmail.value,
        password: form.signInPassword.value
      };

      SignInService.SignIn(input).then((data: any) => {
        if (data.body.user?.id) {
          setItem('token', data.body.token);
          setToken(data.body.token);
          setItem('user', JSON.stringify(data.body.user as IUser));
          setUser(data.body.user as IUser);
          setIsUserSignedIn(true);
        } else {
          ToasterHelper.notify(t('ERRORS.CREDENTIALS_DO_NOT_MATCH'), 'info');
        }
      });
    }
    setValidated(true);
  };

  return (
    <div>
      {token && <Redirect path='/user' />}
      <div>
        <p className='text-center text-sm'>
          <b>{t('SIGN_IN.TITLE')}</b>
        </p>
        <ToastContainer />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <div className='flex flex-col items-center'>
            <div className='flex flex-col items-center col-md-4 text-sm'>
              <div className='col-md-6'>{t('SIGN_IN.EMAIL') + ' *'}</div>
              <div className='col-md-6'>
                <Form.Group className='mb-6' controlId='signInEmail'>
                  <Form.Control type='email' required onChange={validateEmail} placeholder={t('SIGN_IN.EMAIL') + ' *'} />
                  <div>{emailInvalid && <small className='text-danger'>{t('SIGN_IN.VALIDATIONS.EMAIL_VALID')}</small>}</div>
                </Form.Group>
              </div>
            </div>
            <div className='flex flex-col items-center col-md-4 text-sm'>
              <div className='col-md-6'>{t('SIGN_IN.PASSWORD') + ' *'}</div>
              <div className='col-md-6'>
                <Form.Group className='mb-3' controlId='signInPassword'>
                  <InputGroup hasValidation>
                    <Form.Control type='password' required placeholder={t('SIGN_IN.PASSWORD') + ' *'} />
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
          </div>
          <div className='text-center mt-2'>
            <Button className='button-font-size background button-border-radius cursor-pointer' variant='primary' type='submit'>
              <b>{t('SIGN_IN.SIGN_IN_BUTTON')}</b>
            </Button>
          </div>
        </Form>
      </div>
      <div className='text-center mt-2'>
        <Link to='/user/forgot-password'>
          <b>{t('SIGN_IN.FORGOT_PASSWORD')}</b>
        </Link>
      </div>
    </div>
  );
}
